import { Component, Element, Event, EventEmitter, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-tag",
    shadow: false
})
export class Tag {
    @Element() domNode: HTMLUxTagElement;

    /** This connects the tag with the container */
    @Prop({ reflect: true }) readonly reference: string;

    /** If set to true, the tag is removed on click and a uxRemove event is fired */
    @Prop() readonly removable: boolean = false;

    /** Fired when the tag is removed */
    @Event({
        eventName: "uxRemove",
        composed: true,
        cancelable: true,
        bubbles: true
    })
    remove: EventEmitter;

    private removeTag(): void {
        if (!this.removable) {
            return;
        }
        this.remove.emit(this.reference);
        this.domNode.remove();
    }

    render() {
        const { removable } = this;
        return (
            <Host
                class={{
                    ["ux-tag"]: true,
                    ["ux-tag--removable"]: removable
                }}
                onClick={(e: UIEvent) => {
                    e.preventDefault();
                    this.removeTag();
                }}
                tabindex={removable ? 0 : undefined}
            >
                <span class='ux-tag__label'>
                    <slot />
                </span>
                {removable && <ux-icon name='cross' weight='normal' />}
            </Host>
        );
    }
}
